import styled from 'styled-components';

export const StyledTbmStatusChart = styled.div`
  width: 100%;
  height: 370px;
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 0px 6px 0px #00000026;
`;
